import { CoinbaseWallet } from "@web3-react/coinbase-wallet";
import { Web3ReactHooks } from "@web3-react/core";
import { EIP1193 } from "@web3-react/eip1193";
import { MetaMask } from "@web3-react/metamask";
import { WalletConnect } from "@web3-react/walletconnect-v2";

import { ICosmosConnector } from "../interfaces";
import { coinbase, hooks as coinbaseHooks } from "./coinbase";
import { KeplrMobile } from "./cosmos/KeplrMobile/KeplrMobile";
import { keplr } from "./cosmos/keplr";
import { hooks as metaMaskHooks, metamask } from "./metaMask";
import { walletConnect, hooks as walletConnectHooks } from "./walletConnect";

export const staticConnectors: [
  MetaMask | CoinbaseWallet | WalletConnect | EIP1193,
  Web3ReactHooks,
][] = [
  [coinbase, coinbaseHooks],
  [metamask, metaMaskHooks],
  [walletConnect, walletConnectHooks],
];

export const staticConnectorsMap: Record<
  string,
  MetaMask | CoinbaseWallet | WalletConnect | EIP1193
> = {
  coinbase,
  metamask,
  walletConnect,
};

export const cosmosConnectors = [keplr, KeplrMobile];

export const cosmosConnectorsMap: Record<string, ICosmosConnector> = {
  keplr,
  KeplrMobile,
};
